import { compose } from 'redux';

import type { MaintenanceState } from '../maintenanceStore';

const selectPastMaintenanceDomain = (state: MaintenanceState) =>
  state.registerMaintenance;

export const selectMaintenanceItemOptions = compose(
  (state) => state.maintenanceItemOptionsWebData,
  selectPastMaintenanceDomain
);

export const selectReminderPrefill = compose(
  (state) => state.reminderPrefill,
  selectPastMaintenanceDomain
);

export const selectEditMaintenance = compose(
  (state) => state.editMaintenance,
  selectPastMaintenanceDomain
);
